import parseDate from "../../../../controllers/parseDate";
import parseDropDownValue from "../../../../controllers/utils/parseDropDownValue";
import contractTypesForSite from "../../../../data/employee/contractTypesForSite";
import CardForItem from "../../../customUiForCs/CardForItem";
import { useContext } from "react";
import Context from "../../../../Context";

export default function VacationCard({ data, callback }) {
  const { employeeFunctions } = useContext(Context);

  let title = `${parseDate(data.startDate)} - ${parseDate(data.endDate)}`;
  let smallerTitle = `${parseDate(data.startDate)} - ${parseDate(data.endDate)}`;

  let line1 = [
    {
      text: `Commentaire : ${data.note || "Non"}`,
    },
  ];
  let image = null;
  let line2 = null;

  if (data.profile) {
    image = data.profile.profileImage;

    title = `${data.profile.lastName} ${data.profile.firstName}`;

    if (!line2) line2 = [];
    line2.push({ text: data.profile.registrationNumber });
    line2.push({
      text: parseDropDownValue({
        query: data.profile.employeeResponsibility,
        theArray: employeeFunctions || contractTypesForSite,
      }),
    });
  }

  if (data.site) {
    if (!line2) line2 = [];
    line2.push({ text: `${data.site.placeName}` });
  }

  if (data.zone) {
    if (!line2) line2 = [];
    line2.push({ text: `${data.zone.name}` });
  }

  return (
    <CardForItem
      callback={callback}
      itemType={"VACATION"}
      smallerTitle={smallerTitle}
      absolutePath={`/employee/${data.userID}`}
      // image={image}
      title={title}
      line1={line1}
      line2={line2}
      editPath="edit-vacation"
      pagePath={null}
      itemID={data._id}
    />
  );
}
